import { Filter } from "lucide-react";
import { FilterConfig, ProductListConfig } from "@b2b/ui-components";

// Filters config
export const productFilters: FilterConfig[] = [
  {
    type: "button",
    label: "Advanced Filters",
    icon: Filter,
    variant: "outline",
  },
];

// Table config
export const AdminproductTableConfig: ProductListConfig = {
  columns: [
    { key: "product", label: "Product" },
    { key: "seller", label: "Seller" },
    { key: "category", label: "Category" },
    { key: "price", label: "Price" },
    { key: "status", label: "Status" },
    { key: "stock", label: "Stock", align: "center" },
    { key: "orders", label: "Orders", align: "center" },
    { key: "actions", label: "Actions", align: "right" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {
      active: { background: "bg-green-100", textColor: "text-green-700" },
      pending: { background: "bg-yellow-100", textColor: "text-yellow-700" },
      rejected: { background: "bg-red-100", textColor: "text-red-700" },
      draft: { background: "bg-gray-100", textColor: "text-gray-700" },
    },
  },
};

// Note: mockAdminProducts removed - use adminService.getAdminProducts() from @b2b/services instead

// Stats card data (optional, to keep UI dynamic)
export const productStats = [
  {
    value: "156,843",
    label: "Total Products",
    color: "bg-orange-600",
  },
  {
    value: "1,247",
    label: "Pending Review",
    color: "bg-orange-300",
  },
  {
    value: "145,287",
    label: "Active Listings",
    color: "bg-green-600",
  },
  {
    value: "309",
    label: "Out of Stock",
    color: "bg-red-600",
  },
];
